module.exports = __webpack_public_path__ + "static/coliving-bedroom-2-41e12ece1e041db7801b778833f6b279.jpg";